
















import { Vue, Component, Prop } from "vue-property-decorator";
import { BACKEND_DATE_FORMAT } from "@/data/date";

@Component
export default class UDateInput extends Vue {
  // Props

  @Prop({
    required: true,
    validator: value => {
      return !!(value === null || value.match(/^\d{4}-\d{2}-\d{2}$/g));
    }
  })
  public value!: string | null;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public isProcessing!: boolean;

  // Getters

  public get rawDate() {
    return this.value;
  }

  public set rawDate(value) {
    this.$emit("input", value);
  }

  public get formattedDate() {
    if (!this.rawDate) return this.rawDate;
    return this.$moment
      .utc(this.rawDate)
      .local()
      .format(this.$t("_datetime.date.long") as string);
  }

  // Methods

  public selectDate() {
    if (this.isDisabled || this.isProcessing) return;
    this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import("@/components/app/global/date/selectDateModal.vue"),
        parent: this,
        canCancel: ["escape", "outside", "button", "x"],
        props: {
          title: this.$t("_action.select_a_date"),
          defaultDate: this.$moment().toDate(),
          onSelect: async date => {
            this.rawDate = this.$moment(date)
              .utc()
              .format(BACKEND_DATE_FORMAT);
          }
        },
        width: 440
      }
    });
  }

  public clearDate() {
    if (this.isDisabled || this.isProcessing) return;
    this.rawDate = null;
  }
}
